import React from 'react'
import { Jumbotron, Alert } from 'react-bootstrap'
import styled from 'styled-components'

export const StyledBootstrapCol = styled(Jumbotron)`
	padding: 1em;
	margin-bottom: 1em;
	box-sizing: border-box;
`
export const StyledBootstrapAlert = styled(Alert)``
